import React, { useEffect, useState, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
// import DateRangePickerFilter3 from 'modules/common/components/DateRangePickerFilter3';
import SelectDateFilter from 'modules/common/components/SelectDateFilter';
import Loading from 'modules/common/components/Loading';
import withDashboard from '../../common/hoc/withDashboard';

import CmsContext from '../../../context/CmsContext';

import * as c from '../constants';
import * as actions from '../actions';

const styles = {
  control: (base) => ({
    ...base,
    minHeight: 24,
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
  clearIndicator: (base) => ({
    ...base,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

const rename = (obj, oldKey, newKey) => {
  if (_.has(obj, oldKey)) {
    _.set(obj, newKey, _.get(obj, oldKey));
    _.unset(obj, oldKey);
  }
  return obj;
};

const renderLegends = (dt) =>
  dt.map((x) => {
    return (
      <div key={x.name} className="legend-item">
        <div
          style={{
            background: `${x.color}`,
            width: 20,
            height: 20,
            marginRight: 20,
            borderRadius: '50%',
            fontSize: '12px',
          }}
        />
        <div className="legend-text">{x.name}</div>
      </div>
    );
  });
function StatisticsContainer({
  getDatedCounts,
  datedCounts,
  createDynamicLineChart,
}) {
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormData] = useState({
    services: { label: 'E-GOVERNMENT', value: 'E-GOVERNMENT' },
  });

  const cmsContext = useContext(CmsContext)
  const CMS_COMPONENTS = cmsContext.findByType('COMPONENTS');

  // update later

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: e,
    });
  };

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    getDatedCounts();
  }, []);

  const handleOnSubmit = (data) => {
    getDatedCounts(data);
  };

  const filterEgovEServices = () => {
    const services = c.STATISTICS || []
    const serviceRenderLists = []
    // maybe refactor later or find a better way to render these values
    if (!_.get(CMS_COMPONENTS, 'REAL_PROPERTY_TAX_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.name === "RPTAX")) // RPT_SERVICES_SUB_MENU
    if (!_.get(CMS_COMPONENTS, 'BTAX_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.name === "BTAX"))
    if (!_.get(CMS_COMPONENTS, 'BPLS_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.name === "BPLS"))
    if (!_.get(CMS_COMPONENTS, 'CEDULA_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.name === "Cedula"))
    if (!_.get(CMS_COMPONENTS, 'CIVIL_REGISTRY_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.name === "Local Civil Registry"))
    if (!_.get(CMS_COMPONENTS, 'OHP_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.name === "OHP"))
    if (!_.get(CMS_COMPONENTS, 'OVRS_SERVICES_SUB_MENU')) serviceRenderLists.push(services.find(item => item.name === "OVR"))

  return serviceRenderLists
  }

  return (
    <div className="stat item-box-shadow">
      <div className="w-100">
        <h4 className="cms-text-primary font-weight-bold pl-2 mb-4">
        Statistics
        </h4>
      </div>
      <div className="d-none stat-header-container">
        {/* <div className="stat-title">Statistics</div> */}
        <div className="stat-select">
          {/* temporary hidden */}
          <Select
            styles={styles}
            placeholder="Select Service"
            value={_.get(formData, 'services')}
            options={c.SERVICES_SELECT}
            onChange={handleChangeSelect('services')}
          />
        </div>
      </div>

      <div className="stat-filters">
        <SelectDateFilter onSubmit={handleOnSubmit} />
      </div>
      {isLoading && <Loading />}
      {createDynamicLineChart(
        datedCounts.values,
        datedCounts.labels,
        {
          xAxisProps: {
            fontSize: '8px',
          },
          yAxisProps: {
          },
          composeOption: {
            bottom: 20,
          },
          size: 300,
        },
        isLoading
      )}
      <div className="legends-wrapper area px-3 w-100">
        <div
          className="render-chart-legends"
          style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'row',
          flexWrap: 'wrap',
          }}
        >
          {renderLegends(filterEgovEServices())}
        </div>
      </div>
    </div>
  );
}

const formatDatedCounts = (data) => {
  const labels = [];
  const values = [];

  const SERVICES = {
    CDL: 'Cedula',
    PSA: 'Civil Registry Office',
    OHP: 'Occupational / Health Permits',
    RPTS: 'RPTAX',
    BTAX: 'BTAX',
  };

  const colors = [
    '#007AB1',
    '#05B7EB',
    '#2F657D',
    '#04B5B5',
    '#055188',
    '#5DA5E0',
    '#4C6085',
    '#4C6085',
    '#323943',
    '#D5F2E8',
  ];

  data.forEach((item, i) => {
    const entries = Object.entries(item).filter(
      (a) => ['name', 'included', 'BPLS'].indexOf(a[0]) < 0
    );

    if (i === 0) {
      entries.forEach((entry, x) => {
        labels[x] = {
          key: SERVICES[entry[0]] ? SERVICES[entry[0]] : entry[0],
          color: colors[x],
        };
      });
    }

    values[i] = rename(
      rename(
        rename(
          rename(item, 'OHP', 'Occupational / Health Permits'),
          'CDL',
          'Cedula'
        ),
        'PSA',
        'Civil Registry Office'
      ),
      'RPTS',
      'RPTAX'
    );
  });

  return {
    labels,
    values,
  };
};

StatisticsContainer.propTypes = {
  createDynamicLineChart: PropTypes.instanceOf(Function).isRequired,
  // // realTimeTransaction: PropTypes.instanceOf(Array).isRequired,
  getDatedCounts: PropTypes.instanceOf(Function).isRequired,
  datedCounts: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  datedCounts: formatDatedCounts(
    _.get(api, `${c.GET_DATED_COUNTS}.list`) || []
  ),
});

const enhance = _.flowRight([
  withDashboard,
  withRouter,
  connect(mapStateToProps, actions),
]);

export default enhance(StatisticsContainer);
